const { jQuery: $ } = window;

export default class TabbedNav {
    #$navbars;

    constructor() {
        this.#$navbars = $(".tabbed_navigation");
    }

    events() {
        this.#$navbars.each(function(i, el) {
            const $navbar = $(el);
            const $mobileNav = $navbar.find(".tabbed_navigation__mobileMenu");
            const $subnav = $navbar.find(".tabbed_navigation__submenu");
            const $subNavWrap = $navbar.find(".tabbed_navigation__subnavWrapper");
            const $mobileLink = $navbar.find(".tabbed_navigation__mobileActive");

            $navbar.find(".tabbed_navigation__navWrapper > .menu > .menu-item > *").on("click", function(e) {
                const $this = $(this).parent();

                e.preventDefault();

                $navbar.find(".js--active").removeClass("js--active");
                $subnav.html($this.children(".sub-menu").html());
                $subNavWrap.css("background", $this.css("background"));
                $this.addClass("js--active");

                // Update next tick
                setTimeout(() => {
                    let $activeLink = $subNavWrap.find(".current-menu-item");

                    if($activeLink.length === 0) {
                        $activeLink = $subNavWrap.find("a:first");
                    }

                    $mobileLink.html($activeLink.text());
                }, 1);
            });

            $mobileNav.on("click", function (e) {
                $subNavWrap.toggleClass("js--open");
            });
        });
    }
}